import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components/macro';
import imgLogo from '../../assets/img/logo.png';
import { ButtonBlue } from '../shared/Button';
import { Link, useLocation } from 'react-router-dom';
import routes from '../../constants/routes';
import {
  TABLET_WIDTH,
  MOBILE_WIDTH,
  HEADER_HEIGHT,
} from '../../constants/dims';
import PreferencesContext from '../../contexts/preferences';
import LaunchGame from './LaunchGame';

const Container = styled.div`
  width: 100%;
  height: ${HEADER_HEIGHT}px;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
  color: ${(props) => props.theme.header.color};
  background-color: ${(props) => props.theme.header.backgroundColor};
  box-sizing: border-box;

  @media screen and (max-width: ${TABLET_WIDTH}px) {
  }

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    position: relative;
    height: auto;
  }
`;

const MaxWidth = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  position: relative;
  max-width: ${TABLET_WIDTH}px;
  align-items: center;
  padding: 20px 68px;
  box-sizing: border-box;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    padding: 20px 20px;
    flex-wrap: wrap;
  }
`;

const Left = styled.div`
  flex: 0 1 353px;
  display: flex;
  padding-right: 24px;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    flex: 1 1 353px;
    justify-content: center;
    margin-bottom: 12px;
    padding-right: 0px;
  }
`;

const Right = styled.div`
  flex: 1 0 167px;
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    flex: 1 1 167px;
    justify-content: center;
    margin-bottom: 12px;
  }
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LaunchText = styled.div`
  font-size: 0.8em;
  margin-bottom: 5px;
  color: rgb(33, 156, 159);
`;

const Header = () => {
  const location = useLocation();
  const { inGame } = useContext(PreferencesContext);

  const [showGetStartedBtn, setShowGetStartedBtn] = useState(true);

  useEffect(() => {
    setShowGetStartedBtn(!/getStarted$/.test(location.pathname));
  }, [location.pathname]);

  return (
    <Container>
      <MaxWidth>
        <Left>
          <Link to={routes.landing}>
            <img src={imgLogo} alt="logo" />
          </Link>
        </Left>
        <Right>
          {showGetStartedBtn && (
            <Center>
              {inGame && (
                <React.Fragment>
                  <LaunchText>Already a subscriber?</LaunchText>
                  <ButtonBlue
                    capitalize
                    onClick={() =>
                      (window.location.href = 'uniwebview://launch_game')
                    }
                  >
                    Launch Game
                  </ButtonBlue>
                </React.Fragment>
              )}

              {!inGame && (
                <LaunchGame
                  style={{ marginTop: 0, marginBottom: 0 }}
                  width={135}
                  label=""
                />
              )}
            </Center>
          )}
        </Right>
      </MaxWidth>
    </Container>
  );
};

export default Header;
